<template>
    <PopupRouterView :showLeftIcon="true" label="Berita Acara Stock Opname Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="beritaacarastockopname"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="beritaAcaraStockOpnameInput">


        <b-card header="BeritaAcaraStockOpname" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="stockOpnamePlans" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Stock Opname Plan" id="fieldset-stock-opname-plan" size="sm" :model.sync="model.stockOpnamePlanId" :isRequired="true" :state="validateState('stockOpnamePlanId')" :errorMessage="getErrorMessage(errorMessage.stockOpnamePlanId, 'stockOpnamePlanId')"   :selected="model.stockOpnamePlan != null ? model.stockOpnamePlan.name : ''" @input="getStockOpnamePlans"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedStockOpnamePlan" />
						<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area" id="fieldset-area" size="sm" :model.sync="model.areaId" :isRequired="true" :state="validateState('areaId')" :errorMessage="getErrorMessage(errorMessage.areaId, 'areaId')"   :selected="model.area != null ? model.area.code : ''" @input="getAreas"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedArea" />
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId" :isRequired="true" :state="validateState('vendorId')" :errorMessage="getErrorMessage(errorMessage.vendorId, 'vendorId')"   :selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" />
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks" :isRequired="true" :state="validateState('remarks')" :errorMessage="getErrorMessage(errorMessage.remarks, 'remarks')"   :isUpdatable ="null"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import BeritaAcaraStockOpname from '@/models/BeritaAcaraStockOpname/BeritaAcaraStockOpname';
import BeritaAcaraStockOpnameList from '@/models/BeritaAcaraStockOpname/BeritaAcaraStockOpnameList';
import BeritaAcaraStockOpnameFilter from '@/filters/BeritaAcaraStockOpname/BeritaAcaraStockOpnameFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';
import StockOpnamePlanFilter from '@/filters/StockOpnamePlan/StockOpnamePlanFilter';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			stockOpnamePlanId: {required},
			areaId: {required},
			vendorId: {required},
			remarks: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				stockOpnamePlanId: { required : "Stock Opname Plan is Required."},
				areaId: { required : "Area is Required."},
				vendorId: { required : "Vendor is Required."},
				remarks: { required : "Remarks is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterBeritaAcaraStockOpname : null,
			currentBeritaAcaraStockOpnamePage : 1,
			beritaAcaraStockOpnamePageSize: 10,
			sortByBeritaAcaraStockOpname: '',
			sortDescBeritaAcaraStockOpname: '',
			stockOpnamePlans: [],
			stockOpnamePlans: [],
			isStockOpnamePlanComboLoading: false,
			areas: [],
			areas: [],
			isAreaComboLoading: false,
			vendors: [],
			vendors: [],
			isVendorComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isStockOpnamePlanComboLoading: false,
			isAreaComboLoading: false,
			isVendorComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getBeritaAcaraStockOpname : async function(id) {
			this.isBusy = true;
			BeritaAcaraStockOpname.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadBeritaAcaraStockOpname = true;
			this.filterBeritaAcaraStockOpname.id = this.modelId;
			BeritaAcaraStockOpname.downloadDataDetail(this, this.filterBeritaAcaraStockOpname).then(result => {
				this.isDownloadBeritaAcaraStockOpname = false;
			}).catch(error => { this.isDownloadBeritaAcaraStockOpname = false; })
		},
		getBeritaAcaraStockOpnames : async function(input) {
			let filter = new BeritaAcaraStockOpnameFilter();
			if (input != undefined) {
				filter.Remarks = input;
			}
			this.isBeritaAcaraStockOpnameComboLoading = true;
			BeritaAcaraStockOpname.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.beritaAcaraStockOpnames = result.data
				}
				this.isBeritaAcaraStockOpnameComboLoading = false;
			})
			.catch(error => {});
		},
		getStockOpnamePlans : async function(input) {
			let filter = new StockOpnamePlanFilter();
			if (input != undefined) {
				filter.name = input;
			}
			StockOpnamePlan.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnamePlans = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStockOpnamePlan(item) {
			if(item == undefined || item == null) {
				this.model.stockOpnamePlanId = null;
				this.model.stockOpnamePlan = null;
			} else {
				this.model.stockOpnamePlanId = item.id;
				this.model.stockOpnamePlan = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedArea(item) {
			if(item == undefined || item == null) {
				this.model.areaId = null;
				this.model.area = null;
			} else {
				this.model.areaId = item.id;
				this.model.area = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.beritaAcaraStockOpnameInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						BeritaAcaraStockOpname.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'beritaacarastockopnameindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						BeritaAcaraStockOpname.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'beritaacarastockopnameindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					BeritaAcaraStockOpname.updateData(this, model, id)
					.catch((error) => {
						this.getBeritaAcaraStockOpname(id);
					});
				}
			});
		},
		onHidden() {
			this.getBeritaAcaraStockOpnames();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterBeritaAcaraStockOpname = new BeritaAcaraStockOpnameFilter();
		//this.getStockOpnamePlans();
		//this.getAreas();
		//this.getVendors();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getBeritaAcaraStockOpname(id);
			} else {
				this.modelId = id;
				this.getBeritaAcaraStockOpname(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
